import { createFileRoute } from '@tanstack/react-router'

import { Merchant360Screen } from './-components/merchant-360-screen.tsx'

export const Route = createFileRoute('/merchants/merchant-360')({
  component: Merchant360Screen
})
